<div  [formGroup]="actionForm">
  <div *ngIf="IsAChainSystemReplacement"> Need to input chain serial number </div>

  <div>
    <mat-form-field class="action-input">
      <input matInput [matDatepicker]="myDatepicker" placeholder="Date of Action"
      (ngModelChange)="pickedActionDate($event)"    min="{{selectedEquipment?.EquipmentSetupDate | date:'yyyy-MM-dd'}}" max = "{{today | date:'yyyy-MM-dd'}}"
    readonly (click)= "myDatepicker.open()"    formControlName="DateControl" >
      <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #myDatepicker></mat-datepicker>
      <!-- [ngModel]="action.ActionDate"  -->
    </mat-form-field>
  </div>

  <div>
    <mat-form-field class="action-input">
      <input matInput placeholder="{{'Action At Equipment SMU/Hourmeter' | translate | async}}" type="number"  [(ngModel)]="actionAtEquipmentSMU"  formControlName='SMUControl' min="0" >
    </mat-form-field>
  </div>

</div>
 <div class="row setup-table-row">
        <div class="setup-component-table-container mat-elevation-z8">
            <mat-table #table [dataSource]="replacingSystemDataSource">

                <ng-container matColumnDef="delete">
                    <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                    <mat-cell *matCellDef="let element">

                      <button (click)="removeElement(element)" mat-icon-button>
                      <mat-icon  aria-label="close">close</mat-icon>
                      </button>
                      <mat-icon class="colorRed component-status-icon" *ngIf="!validateComponent(element).OperationSucceed" aria-label="warning" title="{{validateComponent(element).LastMessage}}">warning</mat-icon>
                      <mat-icon *ngIf="element.DidNotReplace" aria-label="warning" title="This component is not included in this action" class="colorRed component-status-icon">highlight_off</mat-icon>

                      <mat-icon *ngIf="validateComponent(element).OperationSucceed && !element.DidNotReplace" aria-label="success" title="{{validateComponent(element).LastMessage}}" class="colorGreenDark component-status-icon">check_circle</mat-icon>
                   </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Component">
                    <mat-header-cell *matHeaderCellDef> {{'Type' | translate| async}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.CompartTypeTitle}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Type">
                    <mat-header-cell *matHeaderCellDef> <span class="colorRed"> {{'Component' | translate| async}}*</span> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-form-field>
                            <mat-select  [(ngModel)]="element.CompartId">
                            <mat-option *ngFor="let compart of getAvailableCompartList(element.CompartTypeId)"  title="{{'compart.CompartNote' | translate| async}}" [value]="compart.Id">{{compart.CompartTitle}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <!-- <mat-chip-list>
                            <mat-chip title="{{'Number of inspection points' | translate| async}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent"> {{'MP' | translate| async}} :{{element.Compart.MeasurementPointsNo}}</mat-chip>
                        </mat-chip-list> -->
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Position">
                    <mat-header-cell *matHeaderCellDef>{{'Position' | translate| async}}</mat-header-cell>
                    <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Size">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.CompartTypeId == 232">
                            <mat-select name="size" [(ngModel)]="element.ShoeSize" disableRipple>
                                <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-cell>
                </ng-container>


                <ng-container matColumnDef="excluded">
                  <mat-header-cell *matHeaderCellDef> {{'Note' | translate | async}} </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <div *ngIf="element.DidNotReplace == true">
                      {{"This component is excluded in this action" | translate| async}}
                    </div>
                    </mat-cell>
              </ng-container>

                <ng-container matColumnDef="Grouser">
                    <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-form-field *ngIf="element.CompartTypeId == 232">
                            <mat-select name="grouser" [(ngModel)]="element.Grouser">
                                <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Brand">
                    <mat-header-cell *matHeaderCellDef>{{'Brand' | translate| async}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-form-field>
                            <mat-select disableRipple [(ngModel)]="element.MakeId">
                                <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-cell>
                </ng-container>


                <ng-container matColumnDef="BudgetLife">
                    <mat-header-cell *matHeaderCellDef>{{'Budget Life' | translate| async}}</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-form-field>
                            <input matInput [(ngModel)]="element.BudgetLife" min="0">
                        </mat-form-field>
                    </mat-cell>
                </ng-container>


                <ng-container matColumnDef="HoursAtInstall">
                    <mat-header-cell *matHeaderCellDef>{{'Hours at install' | translate| async}}  </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-form-field class="setup-form-full-width">
                            <input type="number" matInput [(ngModel)]="element.HoursAtInstall">
                        </mat-form-field>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="PartCost">
                  <mat-header-cell *matHeaderCellDef>{{'Part Cost' | translate| async}}  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                      <mat-form-field class="setup-form-full-width">
                          <input type="number" matInput [(ngModel)]="element.PartCost">
                          <span matPrefix>$&nbsp;</span>
                      </mat-form-field>
                  </mat-cell>
              </ng-container>


              <ng-container matColumnDef="LabourCost">
                <mat-header-cell *matHeaderCellDef>{{'Labour Cost' | translate| async}}  </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <mat-form-field class="setup-form-full-width">
                        <input type="number" matInput [(ngModel)]="element.LabourCost">
                        <span matPrefix>$&nbsp;</span>
                    </mat-form-field>
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="MiscCost">
              <mat-header-cell *matHeaderCellDef>{{'MiscCost' | translate| async}}  </mat-header-cell>
              <mat-cell *matCellDef="let element">
                  <mat-form-field class="setup-form-full-width">
                      <input type="number" matInput [(ngModel)]="element.MiscCost">
                      <span matPrefix>$&nbsp;</span>
                  </mat-form-field>
              </mat-cell>
          </ng-container>




                <!-- <ng-container matColumnDef="Position">
                  <mat-header-cell *matHeaderCellDef>{{'Position' | translate| async}}</mat-header-cell>
                  <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="BudgetLife">
                <mat-header-cell *matHeaderCellDef>{{'Budget Life' | translate| async}}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <mat-form-field>
                        <input matInput [(ngModel)]="element.BudgetLife">
                    </mat-form-field>
                </mat-cell>
            </ng-container> -->



                <ng-container matColumnDef="groupHeader">
                  <td colspan="999" mat-cell *matCellDef="let groupBy">
                  <div>
                    <strong>{{groupBy.systemType === 1 ? "Chain Components" : "Frame Components" | translate | async}}</strong>
                  </div>
                  <div>
                      Please Change the components that have been replaced only
                  </div>
                </td>
                </ng-container>


                <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: _displayedColumns;" [ngStyle]="row.DidNotReplace && { 'background-color': 'lightgrey'}"   ></mat-row>
                <mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup"> </mat-row>
            </mat-table>
        </div>
    </div>
